import {CheckCircleIcon, ExclamationTriangleIcon} from '@heroicons/react/24/outline';
import {metricFieldMap} from "../../../../config/user/paymentMetrics";

export const getPaymentTableColumns = (selectedMetric, blurSensitive) => [

  blurSensitive ?
    (
      {
        name: 'Email',
        selector: row => row.email,
        cell: row => (
          <span className='block truncate blur-sm select-none'>
      {row.email}
    </span>
        ),
        sortable: true,
        grow: 1,
        minWidth: '180px',
      }
    ) :
    (
      {
        name: 'Email', selector: row => row.email, sortable: true,
        grow: 1, minWidth: '180px',
      }
    ),
  {
    name: 'Recipient',
    selector: row => row.invoice_recipient || '',
    sortable: true,
    grow: 1,
    minWidth: '180px',
    cell: row => {
      // null => forecaster opted out of invoice emails
      if (row.invoice_recipient == null) {
        return (
          <span className="text-red-600" title="Invoice emails disabled by forecaster">
            Opted out
          </span>
        );
      }
      const redirected = row.invoice_recipient !== row.email;
      // Match the Email column: default (non-custom) cells truncate with an
      // ellipsis; custom cells don't, so replicate it via `truncate` and put
      // the full address in the title. Omit the title when blurred so hover
      // can't reveal the masked email.
      return blurSensitive
        ? (
          <span className="block truncate blur-sm select-none">
            {row.invoice_recipient}
          </span>
        )
        : (
          <span
            className={`block truncate ${redirected ? 'text-amber-600' : ''}`}
            title={row.invoice_recipient}
          >
            {row.invoice_recipient}
          </span>
        );
    },
  },
  {
    name: 'Rank',
    selector: row => row[metricFieldMap[selectedMetric].rank],
    sortable: true,
    grow: 0,
    width: '84px',
    format: row => {
      const rank = row[metricFieldMap[selectedMetric].rank];
      return rank ? rank.toFixed(2) : 'N/A';
    },
  },
  {
    name: 'Outstanding',
    selector: row => row[metricFieldMap[selectedMetric].outstanding],
    sortable: true,
    grow: 0,
    width: '118px',
    format: row => `€${row[metricFieldMap[selectedMetric].outstanding].toFixed(2)}`,
  },
  {
    name: 'Month Payment',
    selector: row => row[metricFieldMap[selectedMetric].month],
    sortable: true,
    grow: 0,
    width: '132px',
    format: row => `€${row[metricFieldMap[selectedMetric].month].toFixed(2)}`,
  },
  {
    name: 'Total Payment',
    selector: row => row[metricFieldMap[selectedMetric].total],
    sortable: true,
    grow: 0,
    width: '126px',
    format: row => `€${row[metricFieldMap[selectedMetric].total].toFixed(2)}`,
  },
  {
    name: 'Email Sent',
    selector: row => row.email_sent ? 1 : 0,
    sortable: true,
    grow: 0,
    width: '112px',
    cell: row => (
      row.email_sent
        ? <CheckCircleIcon className="h-5 w-5 text-green-600" title="Email sent"/>
        : <ExclamationTriangleIcon className="h-5 w-5 text-red-600" title="Email not sent"/>
    ),
  },
];